import { getAnalyticsProvider } from './providers';
/**
 * Process-singleton cache of the analytics provider. Events are stateless
 * POSTs, so caching at module level (not per-render) avoids re-allocating the
 * provider on every component render and matches how `installMrRecommendationsRefresh`
 * uses module-level state for the same idempotent-init reason.
 */
let cachedProvider = null;
export function useAnalytics() {
    if (!cachedProvider)
        cachedProvider = getAnalyticsProvider();
    return cachedProvider;
}
/**
 * Test-only reset. Lets unit tests swap in a Null/mock provider between cases
 * without polluting the module cache. Production code should never call this.
 */
export function __resetAnalyticsProviderForTests() {
    cachedProvider = null;
}
